module.exports = __webpack_public_path__ + "img/simba.c2782366.svg";